import { useMutation } from '@tanstack/react-query';

import { PostEmailPayload, PostEmailResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';

export const postEmail = (payload: PostEmailPayload): Promise<PostEmailResponse> => {
    return axios.post('/profile/change-email', payload);
};

type UsePostEmailOptions = {
    config?: MutationConfig<typeof postEmail>;
    data?: PostEmailPayload;
};

export const usePostEmail = ({ config }: UsePostEmailOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postEmail,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['user-account'] }),
    });
};
